import FiltersType from './listingFiltersTypesConstants';

export default {
  path: '/partner-staffs/board-members',
  filters: [
    {
      key: 'fulltext',
      placeholder: 'Wpisz frazę do znalezienia',
      shortPlaceholder: 'Szukaj',
      badge: 'Szukana fraza:',
      testName: 'hub_filter_search',
      inputType: FiltersType.TEXT_SEARCH_TYPE,
      reset: async () => ({ value: '' }),
    },
    {
      key: 'share.value',
      reset: async () => ({ value: { fromVal: null, toVal: null } }),
      placeholder: 'Posiadane udziały',
      badge: 'Posiadane udziały:',
      testName: 'test_filter_invoice_total_net_value',
      inputType: FiltersType.RANGE_TYPE,
      htmlInputType: 'number',
    },
  ],
};
